export default __webpack_public_path__ + "static/media/register01.dceab475.png";